import { Collapse, Row, Col, Tooltip, Input, Form } from "antd";
import React, { createRef, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { CollapseComponent } from "../../../components/Collapse";
import TimeSpentStore from "../../../DataStores/TimeSpentStore";
import { inject, observer } from "mobx-react";

import "../../../styles/components.scss";
import { dataSuperior, dataSuperior0 } from "../../../utils/Utils";
import { toJS } from "mobx";

const { Panel } = Collapse;

const TimeSpent = ({ ToolStore, displayAll }) => {
  const [form] = Form.useForm();
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    form.setFieldsValue(TimeSpentStore.toFormatJson());
    if (
      (toJS(TimeSpentStore.data)[0].value[0].display != -1 &&
        toJS(TimeSpentStore.data)[0].value[0].display) ||
      (toJS(TimeSpentStore.data)[0].value[1].display != -1 &&
        toJS(TimeSpentStore.data)[0].value[1].display)
    ) {
      setDisplay(true);
    } else {
      setDisplay(false || displayAll);
    }
  }, [TimeSpentStore.data, ToolStore.numbersToTest, ToolStore.conditions]);

  const onChange = (first, e) => {
    if (!TimeSpentStore.changed[first]) {
      var json = form.getFieldsValue();
      json[first] = parseFloat(e.nativeEvent.data);
      form.setFieldsValue(json);
    }
    const c = { ...TimeSpentStore.changed };
    c[first] = true;
    TimeSpentStore.setChanged(c);
  };

  const onBlur = (ev, id) => {
    if (ev.target.value == "") {
      var json = form.getFieldsValue();
      json[id] = TimeSpentStore.defaultsValues[id];
      form.setFieldsValue(json);
      const c = { ...TimeSpentStore.changed };

      c[id] = false;
      TimeSpentStore.setChanged(c);
    }
  };
  const toGetSubElements = (element) => {
    var items = [];

    element.value.forEach((e) => {
      if (e.display) {
        items.push(e);
      }
    });
    return items;
  };

  const elements = () => {
    const doctorTimeSpent = TimeSpentStore.getData()[0].value[0];
    const staffTimeSpent = TimeSpentStore.getData()[0].value[1];
    const staffTimeSpentItems = toGetSubElements(staffTimeSpent);
    if (displayAll) {
      return (
        <>
          <Row>
            <>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="doctorTimeSpentTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="doctorTimeSpent" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="doctorTimeSpent"
                      rules={[{ validator: dataSuperior }]}
                    >
                      <Input
                        type="number"
                        suffix={
                          doctorTimeSpent.suffix && doctorTimeSpent.suffix
                        }
                        prefix={
                          doctorTimeSpent.prefix && doctorTimeSpent.prefix
                        }
                        className={
                          !TimeSpentStore.changed.doctorTimeSpent &&
                          "roi--input-default"
                        }
                        onChange={(e) => onChange("doctorTimeSpent", e)}
                        onBlur={(e) => onBlur(e, "doctorTimeSpent")}
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="staffTimeSpentTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="staffTimeSpent" />
                    </span>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="dentalAssistant" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="staffTimeSpentdentalAssistant"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={staffTimeSpentItems[0].prefix}
                        suffix={staffTimeSpentItems[0].suffix}
                        className={
                          !TimeSpentStore.changed
                            .staffTimeSpentdentalAssistant &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(e, "staffTimeSpentdentalAssistant")
                        }
                        onChange={(e) =>
                          onChange("staffTimeSpentdentalAssistant", e)
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>

                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="treatmentCoordinator" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="staffTimeSpenttreatmentCoordinator"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={staffTimeSpentItems[1].prefix}
                        suffix={staffTimeSpentItems[1].suffix}
                        className={
                          !TimeSpentStore.changed
                            .staffTimeSpenttreatmentCoordinator &&
                          "roi--input-default"
                        }
                        onBlur={(e) =>
                          onBlur(e, "staffTimeSpenttreatmentCoordinator")
                        }
                        onChange={(e) =>
                          onChange("staffTimeSpenttreatmentCoordinator", e)
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="frontDesk" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="staffTimeSpentfrontDesk"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={staffTimeSpentItems[2].prefix}
                        suffix={staffTimeSpentItems[2].suffix}
                        className={
                          !TimeSpentStore.changed.staffTimeSpentfrontDesk &&
                          "roi--input-default"
                        }
                        onBlur={(e) => onBlur(e, "staffTimeSpentfrontDesk")}
                        onChange={(e) => onChange("staffTimeSpentfrontDesk", e)}
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>{" "}
            </>
          </Row>
        </>
      );
    }

    return (
      <Row>
        {doctorTimeSpent.display != -1 && doctorTimeSpent.display && (
          <>
            <Col xl={10} md={24}>
              <Row>
                <Col xl={2} md={2}>
                  <Tooltip
                    color="#EBEBEA"
                    fontFamily="Gotham"
                    fontSize="20px"
                    style={{ textColor: "#6a6e80" }}
                    placement="rightTop"
                    title={<FormattedMessage id="doctorTimeSpentTooltip" />}
                  >
                    <img src="/images/icons/bull.svg" />
                  </Tooltip>
                </Col>
                <Col md={12} xl={14}>
                  <span
                    className="roi--label-section"
                    style={{ marginTop: "10px" }}
                  >
                    <FormattedMessage id="doctorTimeSpent" />
                  </span>
                </Col>
                <Col md={6} xl={8}>
                  <Form.Item
                    name="doctorTimeSpent"
                    rules={[{ validator: dataSuperior }]}
                  >
                    <Input
                      type="number"
                      suffix={doctorTimeSpent.suffix && doctorTimeSpent.suffix}
                      prefix={doctorTimeSpent.prefix && doctorTimeSpent.prefix}
                      className={
                        !TimeSpentStore.changed.doctorTimeSpent &&
                        "roi--input-default"
                      }
                      onChange={(e) => onChange("doctorTimeSpent", e)}
                      onBlur={(e) => onBlur(e, "doctorTimeSpent")}
                    ></Input>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col xl={2} md={0} xs={0}></Col>
          </>
        )}
        {staffTimeSpent.display != -1 &&
          staffTimeSpent.display &&
          staffTimeSpentItems.length > 0 && (
            <>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="staffTimeSpentTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="staffTimeSpent" />
                    </span>
                  </Col>
                  {!ToolStore.conditions.separateStaffRole && (
                    <Col md={6} xl={8}>
                      <Form.Item
                        name="staffTimeSpentdentalAssistant"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          type="number"
                          suffix={
                            staffTimeSpentItems[0].suffix &&
                            staffTimeSpentItems[0].suffix
                          }
                          prefix={
                            staffTimeSpentItems[0].prefix &&
                            staffTimeSpentItems[0].prefix
                          }
                          className={
                            !TimeSpentStore.changed
                              .staffTimeSpentdentalAssistant &&
                            "roi--input-default"
                          }
                          onChange={(e) =>
                            onChange("staffTimeSpentdentalAssistant", e)
                          }
                          onBlur={(e) =>
                            onBlur(e, "staffTimeSpentdentalAssistant")
                          }
                        ></Input>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
                {ToolStore.conditions.separateStaffRole &&
                  staffTimeSpentItems.length > 1 && (
                    <>
                      <Row style={{ marginTop: "1vh" }}>
                        <Col xl={2} md={2} />
                        <Col xl={14} md={12}>
                          <span className="roi--label-section roi--border-adults">
                            <FormattedMessage id="dentalAssistant" />
                          </span>
                        </Col>
                        <Col xl={8} md={6}>
                          <Form.Item
                            name="staffTimeSpentdentalAssistant"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              prefix={staffTimeSpentItems[0].prefix}
                              suffix={staffTimeSpentItems[0].suffix}
                              className={
                                !TimeSpentStore.changed
                                  .staffTimeSpentdentalAssistant &&
                                "roi--input-default"
                              }
                              onBlur={(e) =>
                                onBlur(e, "staffTimeSpentdentalAssistant")
                              }
                              onChange={(e) =>
                                onChange("staffTimeSpentdentalAssistant", e)
                              }
                              type="number"
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row style={{ marginTop: "1vh" }}>
                        <Col xl={2} md={2} />
                        <Col xl={14} md={12}>
                          <span className="roi--label-section roi--border-adults">
                            <FormattedMessage id="treatmentCoordinator" />
                          </span>
                        </Col>
                        <Col xl={8} md={6}>
                          <Form.Item
                            name="staffTimeSpenttreatmentCoordinator"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              prefix={staffTimeSpentItems[1].prefix}
                              suffix={staffTimeSpentItems[1].suffix}
                              className={
                                !TimeSpentStore.changed
                                  .staffTimeSpenttreatmentCoordinator &&
                                "roi--input-default"
                              }
                              onBlur={(e) =>
                                onBlur(e, "staffTimeSpenttreatmentCoordinator")
                              }
                              onChange={(e) =>
                                onChange(
                                  "staffTimeSpenttreatmentCoordinator",
                                  e
                                )
                              }
                              type="number"
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "1vh" }}>
                        <Col xl={2} md={2} />
                        <Col xl={14} md={12}>
                          <span className="roi--label-section roi--border-adults">
                            <FormattedMessage id="frontDesk" />
                          </span>
                        </Col>
                        <Col xl={8} md={6}>
                          <Form.Item
                            name="staffTimeSpentfrontDesk"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              prefix={staffTimeSpentItems[2].prefix}
                              suffix={staffTimeSpentItems[2].suffix}
                              className={
                                !TimeSpentStore.changed
                                  .staffTimeSpentfrontDesk &&
                                "roi--input-default"
                              }
                              onBlur={(e) =>
                                onBlur(e, "staffTimeSpentfrontDesk")
                              }
                              onChange={(e) =>
                                onChange("staffTimeSpentfrontDesk", e)
                              }
                              type="number"
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}
              </Col>{" "}
            </>
          )}
      </Row>
    );
  };

  return (
    <>
      {display && (
        <Form
          form={form}
          onChange={() =>
            TimeSpentStore.toUpdateTimeSpent(form.getFieldsValue())
          }
        >
          <CollapseComponent
            style={{ marginBottom: "2vh", marginTop: "2vh" }}
            headerText={<FormattedMessage id="timeSpentOnTheExam" />}
            classNameHeader="roi--collapse-header-green"
            content={TimeSpentStore.data != null && <>{elements()}</>}
          ></CollapseComponent>
        </Form>
      )}
    </>
  );
};

export default inject("ToolStore")(observer(TimeSpent));
